/*
 * PanamaJack — Cuenta (tabs SPA) + hover de color en grid.
 * Extraido de theme.js durante el rebase a Showcase 10.2.0 (iso-funcional). Requiere jQuery.
 * CONTIENE DOS FEATURES (se separaran/reworkearan en Fase B):
 *  (1) account-tabs: navegacion por pestanas de /account (#menu_movil, #container-account,
 *      .sidebar_menu_enc, paneles .section-content) + deep-link ?tipo= en /account.
 *  (2) box-colores-hover (PORT_HARD): al hover en .product-block (>=1083px) intercambia la
 *      variante de color mostrada. ACOPLADO a markup 6.0.0 de product-block → al rebasar la
 *      tarjeta a 10.2.0 (Fase B) hay que actualizar selectores/imagenes aqui.
 */
(function () {
  var $ = (window.theme && window.theme.jQuery) || window.jQuery;
  if (!$) return;

  document.addEventListener('click', function (event) {
    var zoom = event.target.closest('.pj-order__zoom');
    if (zoom) {
      event.preventDefault();
      var src = zoom.getAttribute('data-full');
      if (!src) return;
      var layer = document.querySelector('.pj-order-zoom');
      if (!layer) {
        layer = document.createElement('div');
        layer.className = 'pj-order-zoom';
        layer.innerHTML = '<button type="button" class="pj-order-zoom__close"></button><img alt="">';
        document.body.appendChild(layer);
        layer.addEventListener('click', function (clickEvent) {
          if (clickEvent.target === layer || clickEvent.target.closest('.pj-order-zoom__close')) {
            layer.classList.remove('is-open');
          }
        });
      }
      var closeLabel = zoom.getAttribute('data-close') || '';
      layer.querySelector('.pj-order-zoom__close').textContent = '\u00d7';
      layer.querySelector('.pj-order-zoom__close').setAttribute('aria-label', closeLabel);
      var image = layer.querySelector('img');
      image.src = src;
      image.alt = zoom.getAttribute('data-alt') || '';
      layer.classList.add('is-open');
      return;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var layer = document.querySelector('.pj-order-zoom');
    if (layer) layer.classList.remove('is-open');
  });

  $('#menu_movil .sidebar_menu_enc a').click(function(e) {
    e.preventDefault();  // Prevenir la acción por defecto de los enlaces
    var targetId = $(this).data('target');  // Obtener el ID de la sección a mostrar

    // Ocultar todas las secciones
    $('.section-content').addClass('hidden');
    //console.log(targetId);
    // Mostrar solo la sección relevante
    $('#' + targetId).removeClass('hidden');

    // Actualizar la clase 'selected' en movil y escritorio
    $('.sidebar_menu_enc a').removeClass('selected');
    $('.sidebar_menu_enc a[data-target="' + targetId + '"]').addClass('selected');

    var tittle = $(this).data('title');
    $('#title-page-account').text(tittle);
  });

  $('#container-account .sidebar_menu_enc a').click(function(e) {
    e.preventDefault();  // Prevenir la acción por defecto de los enlaces
    var targetId = $(this).data('target');  // Obtener el ID de la sección a mostrar

    // Ocultar todas las secciones
    $('.section-content').addClass('hidden');
    //console.log(targetId);
    // Mostrar solo la sección relevante
    $('#' + targetId).removeClass('hidden');

    // Actualizar la clase 'selected' en movil y escritorio
    $('.sidebar_menu_enc a').removeClass('selected');
    $('.sidebar_menu_enc a[data-target="' + targetId + '"]').addClass('selected');

    var tittle = $(this).data('title');
    $('#title-page-account').text(tittle);
    
 

    
  });

  $(document).ready(function() {
    function applyCardTitle($root, name, color) {
      var $title = $root.find('.title').first();
      var $name = $title.find('.title-name');
      if ($name.length) {
        $name.text(name == null ? '' : name);
        if (typeof color !== 'undefined') {
          var colorText = $.trim(color || '');
          $title.find('.title-color').text(colorText ? ' ' + colorText : '');
        }
      } else if (name != null) {
        $title.text(name);
      }
    }

    function applyForrosTag($root, html) {
      var $tag = $root.find('.product-tag--forros');
      if (!$tag.length) return;
      var value = $.trim(html || '');
      if (value === '') {
        $tag.attr('hidden', 'hidden').empty();
      } else {
        $tag.html(html).removeAttr('hidden');
      }
    }

    var path = window.location.pathname;
    var searchParams = window.location.search;

    // Comprobar si estamos en la página /account
    if (path === '/account') {
       // console.log('Estamos en la página /account');

        // Comprobar si hay parámetros GET
        if (searchParams) {

          const params = new URLSearchParams(window.location.search);
          var tipo = params.get('tipo');
          if (!tipo && params.get('page')) {
            tipo = 'pedidos';
          }
          if (tipo) {
            $('a[data-target="'+ tipo +'"]').click();
            if ($('#container-account .sidebar_menu_enc a[data-target="'+ tipo +'"]').is(":visible")) {
                $('#container-account .sidebar_menu_enc a[data-target="'+ tipo +'"]').click();
            } else {
                $('#menu_movil .sidebar_menu_enc a[data-target="'+ tipo +'"]').click();
            }
          }
          var url = new URL(window.location);
          url.searchParams.delete('tipo'); // Elimina el parámetro 'tipo'
      
          // Actualiza la URL sin recargar la página
          window.history.pushState({}, '', url);
        }
    }

    $(function() {
      function checkWindowSize() {
          return $(window).width() >= 1083;
      }
  
      $(document).on('mouseenter', '.product-block', function() {
          if (checkWindowSize()) {
              $(this).find('.box-colores').show(); // Mostrar el elemento .box-colores solo si la ventana es >= 1100px
              $(this).find('.colors').hide();
            
              let currentSrcset = $(this).find('.product-block__inner .image .image__first .rimage__image').attr('srcset');
              $(this).find('.product-block__inner .image .image__first .rimage__image').attr('data-original-srcset', currentSrcset); // Usamos attr para guardar el valor
              
      
              let $titleEl = $(this).find('.title').first();
              let $titleName = $titleEl.find('.title-name');
              let currenttitleset = $titleName.length ? $titleName.text() : $titleEl.text();
              $(this).find('.product-block__inner .image .image__first .rimage__image').attr('data-original-titleset', currenttitleset); // Usamos attr para guardar el valor
              $(this).find('.product-block__inner .image .image__first .rimage__image').attr('data-original-colorset', $.trim($titleEl.find('.title-color').text() || ''));

              let currentpriceset = $(this).find('.product-block__inner .image .image__first .rimage__image').closest('.product-block__inner').find('.price .theme-money').first().text();
              $(this).find('.product-block__inner .image .image__first .rimage__image').attr('data-original-priceset', currentpriceset); // Usamos attr para guardar el valor
              

              
            
              let currentrebajaset = $(this).find('.product-block__inner .image .image__first .rimage__image').closest('.product-block__inner').find('.price .was-price').text();
              if(currentpriceset == currentrebajaset || currentrebajaset == '0,00€'){
                currentrebajaset = '';
              }
            
              $(this).find('.product-block__inner .image .image__first .rimage__image').attr('data-original-rebajaset', currentrebajaset); // Usamos attr para guardar el valor

              let $forrosTag = $(this).find('.product-tag--forros');
              $(this).find('.product-block__inner .image .image__first .rimage__image')
                .attr('data-original-forros', $forrosTag.html() || '')
                .attr('data-original-forros-hidden', $forrosTag.is('[hidden]') ? '1' : '0');
             
          }
      }).on('mouseleave', '.product-block', function() {
          if (checkWindowSize()) {
              $(this).find('.box-colores').hide(); // Ocultar el elemento .box-colores solo si la ventana es >= 1100px
              $(this).find('.colors').show();
          }
      });
  });


    $('.box-colores .color-swatch-wrapper').hover(function() {
        // Al entrar (hover), cambiamos la imagen
        let img_prod = $(this).data('img');
        let title_prod = $(this).data('title');
        let price_prod = $(this).data('precio');
        let rebaja_prod = $(this).data('rebaja');
       
        
        let imageContainer = $(this).closest('.product-block__inner').find('.image .image__first .rimage__image');
        let priceContainer = $(this).closest('.product-block__inner').find('.price .theme-money').first();
        let rebajaContainer = $(this).closest('.product-block__inner').find('.price .was-price');
      
       
        // Establecemos el nuevo srcset
        imageContainer.attr('srcset', img_prod);
        applyCardTitle($(this).closest('.product-block__inner'), title_prod, $(this).attr('data-color'));
        priceContainer.text(price_prod);
        if(price_prod == rebaja_prod || rebaja_prod == '0,00€'){
          rebaja_prod = '';
        }
      
        rebajaContainer.text(rebaja_prod);

        let forrosProd = $(this).attr('data-forros');
        if (typeof forrosProd !== 'undefined') {
            applyForrosTag($(this).closest('.product-block__inner'), forrosProd);
        }
    });


     $(document).on('mouseenter', '.box-colores .color-swatch-wrapper', function() {
        // Al entrar (mouseenter), cambiamos la imagen y el título
        let img_prod = $(this).data('img');
        let title_prod = $(this).data('title');
        let price_prod = $(this).data('precio');
      
        let rebaja_prod = $(this).data('rebaja');
        let imageContainer = $(this).closest('.product-block__inner').find('.image .image__first .rimage__image');
        let priceContainer = $(this).closest('.product-block__inner').find('.price .theme-money').first();
        let rebajaContainer = $(this).closest('.product-block__inner').find('.price .was-price');

        // Establecemos el nuevo srcset y el texto del título
        imageContainer.attr('srcset', img_prod);
        applyCardTitle($(this).closest('.product-block__inner'), title_prod, $(this).attr('data-color'));
        priceContainer.text(price_prod);

        if(price_prod == rebaja_prod || rebaja_prod == '0,00€'){
          rebaja_prod = '';
        }
        rebajaContainer.text(rebaja_prod);

        let forrosProd = $(this).attr('data-forros');
        if (typeof forrosProd !== 'undefined') {
            applyForrosTag($(this).closest('.product-block__inner'), forrosProd);
        }
    });

 

  // Usar .on() con 'mouseleave' en el elemento body para escuchar eventos en el contenedor .box-colores
    $(document).on('mouseleave', '.box-colores', function() {
        // Cuando el mouse sale del contenedor, restauramos las imágenes y títulos originales
        $(this).closest('.product-block__inner').find('.image .image__first .rimage__image').each(function() {
            let originalSrcset = $(this).attr('data-original-srcset'); // Usamos attr para obtener el valor
            let originaltitleset = $(this).attr('data-original-titleset'); // Usamos attr para obtener el valor
            let originalpriceset = $(this).attr('data-original-priceset'); // Usamos attr para obtener el valor
            let originalrebajaset = $(this).attr('data-original-rebajaset'); // Usamos attr para obtener el valor
  
          
            if (originalSrcset) { // Solo actualizamos si existe un srcset original guardado
                $(this).attr('srcset', originalSrcset);
                applyCardTitle($(this).closest('.product-block__inner'), originaltitleset, $(this).attr('data-original-colorset'));
                $(this).closest('.product-block__inner').find('.price .theme-money').first().text(originalpriceset);
                $(this).closest('.product-block__inner').find('.price .was-price').first().text(originalrebajaset);

                let originalForros = $(this).attr('data-original-forros');
                let originalForrosHidden = $(this).attr('data-original-forros-hidden');
                if (typeof originalForros !== 'undefined') {
                    applyForrosTag($(this).closest('.product-block__inner'), originalForrosHidden === '1' ? '' : originalForros);
                }
            }
        });
    });


    
    
    /* PJ search-clear + read-more (leer_mas/_bm) -> extraidos a pj-search-clear.js y pj-read-more.js (rebase 10.2.0) */


});
})();
